import { AxiosResponse } from 'axios';
import { MyHealer } from '../../../../core/models/my-healer';
import { UserProfile } from '../../../../core/models/user-profile';
import backendHttpClient from '../../../http/axios/axios-http-client';
import { HealerUserProfileResponseDTO } from './dto/HealerUserProfileResponse.dto';
import { MyHealersResponseDTO } from './dto/my-healers-response.dto';
import { UpdateClientUserProfileDTO } from './dto/update-client-user-profile.dto';

const ENDPOINT = '/public/user-profile/client';

export interface ClientUserProfileGateway {
  getClientUserProfile(clientUserProfileId: string): Promise<UserProfile>;
  updateClientUserProfile(clientUserProfileId: string, body: UpdateClientUserProfileDTO): Promise<UserProfile>;
  fetchMyHealers(clientUserProfileId: string): Promise<MyHealer[]>;
  fetchMyHealerSingle(clientUserProfileId: string, healerUserProfileId: string): Promise<MyHealer>;
  sendLoginCredentialsMail(clientEmail: string): Promise<void>;
  getHealerProfile(healerUserProfileId: string): Promise<HealerUserProfileResponseDTO>;
}

export class ClientUserProfileGateway implements ClientUserProfileGateway {
  async sendLoginCredentialsMail(clientEmail: string): Promise<void> {
    const endpoint = `${ENDPOINT}/send-login-details-mail`;

    const response: AxiosResponse<void> = await backendHttpClient.request({
      url: endpoint,
      method: 'POST',
      data: {
        clientEmail,
      },
    });

    return response.data;
  }

  async getClientUserProfile(clientUserProfileId: string): Promise<UserProfile> {
    const endpoint = `${ENDPOINT}/${clientUserProfileId}`;

    const response: AxiosResponse<UserProfile> = await backendHttpClient.request({
      url: endpoint,
      method: 'GET',
    });

    return response.data;
  }

  async updateClientUserProfile(clientUserProfileId: string, body: UpdateClientUserProfileDTO): Promise<UserProfile> {
    const endpoint = `${ENDPOINT}/${clientUserProfileId}`;

    const response: AxiosResponse<UserProfile> = await backendHttpClient.request({
      url: endpoint,
      method: 'POST',
      data: body,
    });

    return response.data;
  }

  async fetchMyHealers(clientUserProfileId: string): Promise<MyHealer[]> {
    const endpoint = `${ENDPOINT}/${clientUserProfileId}/my-healers`;

    const response: AxiosResponse<MyHealersResponseDTO> = await backendHttpClient.request({
      url: endpoint,
      method: 'GET',
    });

    return response.data?.myHealers;
  }

  async fetchMyHealerSingle(clientUserProfileId: string, healerUserProfileId: string): Promise<MyHealer> {
    const endpoint = `${ENDPOINT}/${clientUserProfileId}/${healerUserProfileId}/my-healer`;

    const response: AxiosResponse<MyHealer> = await backendHttpClient.request({
      url: endpoint,
      method: 'GET',
    });

    return response.data;
  }

  async getHealerProfile(healerUserProfileId: string): Promise<HealerUserProfileResponseDTO> {
    const endpoint = `${ENDPOINT}/${healerUserProfileId}/get-healer-profile-info`;

    const response: AxiosResponse<HealerUserProfileResponseDTO> = await backendHttpClient.request({
      url: endpoint,
      method: 'GET',
    });

    return response.data;
  }
}

export default ClientUserProfileGateway;
